import { useEffect } from "react";

/** Install once at the app root. CSS uses this to distinguish pointer-driven
 * focus restoration from keyboard navigation, including in native dialogs. */
export function useInputModality(): void {
    useEffect(() => {
        const root = document.documentElement;
        const previousModality = root.getAttribute("data-input-modality");
        const handlePointerDown = (): void => {
            root.dataset.inputModality = "pointer";
        };
        const handleKeyDown = (event: KeyboardEvent): void => {
            if (["Shift", "Control", "Alt", "Meta"].includes(event.key)) return;

            root.dataset.inputModality = "keyboard";
        };

        // Capture before a control opens a dialog and moves focus. Leave the
        // initial mode unset so assistive/programmatic focus keeps native cues.
        document.addEventListener("pointerdown", handlePointerDown, true);
        document.addEventListener("keydown", handleKeyDown, true);
        return () => {
            document.removeEventListener(
                "pointerdown",
                handlePointerDown,
                true,
            );
            document.removeEventListener("keydown", handleKeyDown, true);
            if (previousModality === null) {
                root.removeAttribute("data-input-modality");
            } else {
                root.setAttribute("data-input-modality", previousModality);
            }
        };
    }, []);
}
